/**
 * useCreateUserLink
 *
 * @returns
 */

import { BASE_URL_CULK } from "../services/createUserLinkAPI";
import {
  CreateUserLink,
  CreateUserLinkPatch,
} from "../types/createUserLink.type";

import { useAuth } from "../../auth/hooks";
import { OrderByType, useGenericAPI } from "../../../utils/genericAPI/useGenericAPI";

export const useCreateUserLink = (config?: {
  organizationId?: string;
  pageSize?: number;
  orderBy?: OrderByType<CreateUserLink>;
}) => {
  return useCreateUserLinkCore({
    organizationId: config?.organizationId,
    pageSize: config?.pageSize,
    orderBy: config?.orderBy,
  });
};

/**
 * useCreateUserLinkCore is a hook that returns all create user links.
 *
 * @param param0
 * @returns
 */
function useCreateUserLinkCore({
  organizationId,
  pageSize = 5,
  orderBy = "-uct_create_at",
}: {
  organizationId?: string;
  pageSize?: number;
  orderBy?: OrderByType<CreateUserLink>;
}) {
  const { setHeaderAuthToRequest } = useAuth();
  setHeaderAuthToRequest();

  const { getAllQuery, createNew } = useGenericAPI<
    CreateUserLink,
    CreateUserLinkPatch,
    CreateUserLinkPatch
  >({
    baseURL: BASE_URL_CULK,
    APIname: "createUserLinks",
    pageSize: pageSize,
    orderBy: orderBy ,
    preFilter:  {
      uct_organization_id: organizationId ? `=${organizationId}` : undefined,
    }
  });

  return {
    allCreateUserLinksQuery: getAllQuery,
    createCreateUserLinkQuery: createNew,
  };
}

export default useCreateUserLink;
